export const FAQS = [
  {
    title: "Can I migrate from a managed service like EKS or GKE?",
    content:
      "Yes. We support full migration of workloads, secrets, and volume claims from major cloud Kubernetes platforms.",
  },
  {
    title: "Will I lose my service mesh (e.g., Istio, Linkerd)?",
    content:
      "No. OneMind PaaS supports custom mesh configurations — including reapplying Istio or integrating your preferred ingress controller.",
  },
  {
    title: "Does the PaaS include observability tools?",
    content:
      "Yes. Elastic Stack, Prometheus, Loki, and Grafana are part of the standard OneMind PaaS bundle.",
  },
  {
    title: "How do you migrate persistent volumes and stateful workloads?",
    content:
      "We use volume snapshotting and dynamic provisioning strategies to safely migrate stateful services like databases.",
  },
  {
    title: "Do I need to rebuild my CI/CD pipelines?",
    content:
      "Not usually. We map your existing pipelines (e.g., ArgoCD, Jenkins, GitHub Actions) to OneMind’s PaaS-supported GitOps flows.",
  },
  {
    title: "What about secrets and config maps?",
    content:
      "All sensitive data is securely migrated using Kubernetes secrets or HashiCorp Vault integration — depending on your security posture.",
  },
];
